// orders created after this date use the card-level change approval flow via chat
export const CARD_CHANGE_FLOW_CUTOFF = new Date('2026-03-31T23:59:59.999Z');

export function isCardLevelChangeFlow(
  orderCreatedAt: Date | string | null | undefined,
): boolean {
  if (!orderCreatedAt) return true;
  return new Date(orderCreatedAt) > CARD_CHANGE_FLOW_CUTOFF;
}
